


































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import DeliveryPeriodRequest from '@/model/request/DeliveryPeriodRequest'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import {ItrackCollection} from '@/helpers'
import {IResource, ObjectCollection} from 'simpli-web-sdk'

@Component({
  components: {ItDateInput},
})
export default class FilterDeliveryPeriod extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DeliveryPeriodRequest

  async mounted( ) {
    await this.value.allCentroDeCusto.query()
    await this.value.allTipoInsumo.query()
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
